import React, { useLayoutEffect, useEffect, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { fetchProgramList, fetchTestimonials } from '../redux/actions/Actions'
import axiosinstance from '../../api/axiosinstance'
import RequestCallback from '../RequestCallback'
import SEO from '../common/SEO'

/* ─── Program card data ────────────────────────────────────── */
const PROGRAM_CARDS = [
  {
    key: 'bootcamp',
    path: '/programs/coding-bootcamp',
    name: 'CODING\nBOOTCAMP',
    tagline: 'Any IT Training Programs',
    duration: '3 – 6 MONTHS',
    durationColor: '#16A34A',
    accent: '#2563EB',
    btnBg: '#2563EB',
    iconWhite: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
      </svg>
    ),
    features: ['Training – 2 Months','Capstone Project','Written Test Assessment to Crack','Mock Interview'],
  },
  {
    key: 'developer',
    path: '/programs/developer-full-time',
    name: 'DEVELOPER\nPROGRAM',
    tagline: 'Build • Code • Deploy',
    duration: '3 – 6 MONTHS',
    durationColor: '#16A34A',
    accent: '#16A34A',
    btnBg: '#16A34A',
    iconWhite: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
      </svg>
    ),
    features: ['Training – 2 Months','Capstone Project','Written Test Assessment to Crack','Mock Interview','Added to Live Project'],
  },
  {
    key: 'internship',
    path: '/programs/internship',
    name: 'INTERNSHIP',
    tagline: 'Learn by Doing',
    duration: 'FLEXIBLE',
    durationColor: '#7C3AED',
    accent: '#7C3AED',
    btnBg: '#7C3AED',
    iconWhite: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
      </svg>
    ),
    features: ['Crash Course','Work on Project','Real-time Experience','Mentorship & Guidance'],
  },
  {
    key: 'esprp',
    path: '/programs/esprp',
    name: 'ESPRP',
    tagline: 'Employability Skills & Placement Readiness Program',
    duration: null,
    durationColor: '#EA580C',
    accent: '#EA580C',
    btnBg: '#EA580C',
    iconWhite: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
    subLabel: 'We Train Students',
    features: ['Written Test Training (Aptitude, Soft Skills, Coding, Puzzles & Problem Analysis)','Interview Preparation','Resume Preparation'],
  },
]

/* ─── Other section data ───────────────────────────────────── */
const ESPRP_MODES = [
  { label: 'Online Programs',  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg> },
  { label: 'Offline Programs', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { label: 'Hybrid Programs',  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
]

const STATS = [
  { value: '5000+', label: 'Students Trained', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.65)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg> },
  { value: '250+',  label: 'Live Projects',    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.65)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg> },
  { value: '200+',  label: 'Hiring Partners',  icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.65)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M2 20c0-4 4-7 10-7s10 3 10 7"/></svg> },
  { value: '90%',   label: 'Placement Rate',   icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.65)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> },
]

const HOW_IT_WORKS = [
  { num: 1, title: 'Enroll',  desc: 'Choose your preferred program and enroll.', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/></svg> },
  { num: 2, title: 'Learn',   desc: 'Get trained by experts with hands-on sessions.', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg> },
  { num: 3, title: 'Build',   desc: 'Work on capstone project to apply your learning.', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg> },
  { num: 4, title: 'Assess',  desc: 'Clear written test assessment and mock interview.', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
  { num: 5, title: 'Succeed', desc: 'Get added to live projects and kickstart your career.', icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
]

const getInitials = (name = '') =>
  name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);

const FALLBACK_PARTNERS = [
  { name:'TATA',       logo_url:'https://logo.clearbit.com/tata.com' },
  { name:'Infosys',    logo_url:'https://logo.clearbit.com/infosys.com' },
  { name:'Wipro',      logo_url:'https://logo.clearbit.com/wipro.com' },
  { name:'Accenture',  logo_url:'https://logo.clearbit.com/accenture.com' },
  { name:'Capgemini',  logo_url:'https://logo.clearbit.com/capgemini.com' },
  { name:'Cognizant',  logo_url:'https://logo.clearbit.com/cognizant.com' },
  { name:'HCL',        logo_url:'https://logo.clearbit.com/hcltech.com' },
]

/* ─── CheckMark icon ───────────────────────────────────────── */
const Check = ({ color }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" style={{ flexShrink: 0, marginTop: 1 }}>
    <circle cx="8.5" cy="8.5" r="8.5" fill={color} />
    <polyline points="4.5,8.5 7.5,11.5 12.5,5.5" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const OrangeDot = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ flexShrink: 0, marginTop: 2 }}>
    <circle cx="8" cy="8" r="8" fill="#EA580C"/>
    <circle cx="8" cy="8" r="3" fill="#fff"/>
  </svg>
)

/* ─── Component ────────────────────────────────────────────── */
const Home = () => {
  const location        = useLocation()
  const navigate        = useNavigate()
  const dispatch        = useDispatch()
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated)
  const programs        = useSelector((s) => s.fetchAllPrograms?.programs || [])
  const testimonials    = useSelector((s) => s.fetchAllTestimonials?.testimonials || [])
  const [slideIdx,      setSlideIdx]      = useState(0)
  const [showApply,     setShowApply]     = useState(false)
  const [hiringPartners, setHiringPartners] = useState([])

  useLayoutEffect(() => { window.scrollTo(0, 0) }, [location])
  useLayoutEffect(() => { if (isAuthenticated) navigate('/dashboard', { replace: true }) }, [isAuthenticated])
  useEffect(() => {
    dispatch(fetchProgramList()); dispatch(fetchTestimonials());
    axiosinstance.get('/api/hiring-partners/active')
      .then((res) => { if (Array.isArray(res.data) && res.data.length > 0) setHiringPartners(res.data); })
      .catch(() => {});
  }, [dispatch])

  const visibleCount = 3
  const maxSlide = Math.max(0, testimonials.length - visibleCount)

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", overflowX: 'hidden' }}>
      <SEO
        path="/"
        description="UPL Snipe offers industry-led tech training programs including Java Full Stack, MERN Stack, Python, Data Science & more. Hands-on live projects, expert mentors, and 95%+ placement support."
        keywords="tech training, coding bootcamp, Java Full Stack, MERN Stack, Python, Data Science, placement support, live projects, UPL Snipe, IT training, software development courses"
      />
      <style>{`
        #home-hero    { background: linear-gradient(135deg,#050D1E 0%,#091525 35%,#0C1B38 65%,#0A1628 100%) !important; }
        #home-esprp   { background-color: #EEF2FF !important; }
        #home-employ  { background-color: #050D1E !important; }
        #home-stats   { background-color: #0B1629 !important; }
        #home-howitworks { background-color: #FFFFFF !important; }
        #home-testimonials { background-color: #F8FAFC !important; }
        #home-cta     { background-color: #0A1628 !important; }

        @media (max-width: 900px) {
          #home-hero-grid        { grid-template-columns: 1fr !important; }
          #home-hero-right       { display: none !important; }
          #home-hero-left        { padding-bottom: 40px !important; }
          #home-hero             { padding: 36px 5% 40px !important; min-height: unset !important; }
          #home-hero h1          { font-size: 36px !important; }
          #home-hero-feats       { gap: 0 !important; }
          #home-prog-grid        { grid-template-columns: repeat(2,1fr) !important; }
          #home-esprp-row        { flex-direction: column !important; gap: 20px !important; }
          .home-esprp-divider    { display: none !important; }
          #home-employ-steps     { grid-template-columns: repeat(2,1fr) !important; }
          #home-employ-audience  { grid-template-columns: 1fr !important; }
          #home-stats-grid       { grid-template-columns: repeat(2,1fr) !important; gap: 16px !important; }
          #home-stats-colleges   { grid-column: 1 / -1 !important; padding: 16px 0 0 !important; }
          #home-hiw-grid         { flex-direction: column !important; align-items: center !important; gap: 24px !important; }
          .home-hiw-arrow        { display: none !important; }
          #home-test-grid        { grid-template-columns: 1fr !important; }
          #home-cta-inner        { flex-direction: column !important; text-align: center !important; align-items: center !important; }
        }
        @media (max-width: 480px) {
          #home-hero h1          { font-size: 28px !important; }
          #home-prog-grid        { grid-template-columns: 1fr !important; }
          #home-employ-steps     { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* ══════════════════════════════════════════════
          HERO SECTION
      ══════════════════════════════════════════════ */}
      <section id="home-hero" style={{
        background: 'linear-gradient(135deg,#050D1E 0%,#091525 35%,#0C1B38 65%,#0A1628 100%)',
        padding: '56px 5% 0',
        position: 'relative',
        overflow: 'hidden',
        minHeight: 600,
      }}>
        {/* Subtle radial glow top-right */}
        <div style={{ position:'absolute',top:'-20%',right:'-5%',width:640,height:640,background:'radial-gradient(circle,rgba(37,99,235,0.22) 0%,transparent 62%)',pointerEvents:'none' }} />
        {/* Subtle radial glow bottom-left */}
        <div style={{ position:'absolute',bottom:'-10%',left:'5%',width:360,height:360,background:'radial-gradient(circle,rgba(14,165,233,0.1) 0%,transparent 65%)',pointerEvents:'none' }} />

        <div id="home-hero-grid" style={{ maxWidth:1200,margin:'0 auto',display:'grid',gridTemplateColumns:'46% 54%',gap:0,alignItems:'flex-end' }}>

          {/* ── LEFT: Text content ── */}
          <div id="home-hero-left" style={{ paddingBottom: 52 }}>
            <h1 style={{ fontSize:60,fontWeight:900,lineHeight:1.02,margin:'0 0 18px',letterSpacing:'-0.02em' }}>
              <span style={{ color:'#FFFFFF',display:'block' }}>BUILD SKILLS.</span>
              <span style={{ color:'#1E7EF5',display:'block' }}>BUILD FUTURE.</span>
            </h1>

            <p style={{ fontSize:17,color:'#94A3B8',lineHeight:1.65,margin:'0 0 32px',maxWidth:430 }}>
              Industry-focused programs that turn learners into{' '}
              <span style={{ color:'#F59E0B',fontWeight:700 }}>job-ready professionals.</span>
            </p>

            {/* Feature icons row */}
            <div style={{ display:'flex',gap:0,marginBottom:36,borderTop:'1px solid rgba(255,255,255,0.07)',borderBottom:'1px solid rgba(255,255,255,0.07)',padding:'18px 0' }}>
              {[
                { label:'3 to 6\nMonths\nDuration',    icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> },
                { label:'Hands-on\nTraining',          icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg> },
                { label:'Capstone\nProject',           icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg> },
                { label:'Placement\nSupport',          icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg> },
              ].map((f, i) => (
                <div key={i} style={{ display:'flex',flexDirection:'column',alignItems:'center',gap:8,flex:1,padding:'0 4px',borderRight:i < 3 ? '1px solid rgba(255,255,255,0.07)' : 'none' }}>
                  {f.icon}
                  <span style={{ fontSize:11,color:'rgba(255,255,255,0.6)',fontWeight:500,textAlign:'center',lineHeight:1.4,whiteSpace:'pre-line' }}>{f.label}</span>
                </div>
              ))}
            </div>

            {/* CTA buttons */}
            <div style={{ display:'flex',gap:14,flexWrap:'wrap' }}>
              <Link to="/programs" style={{
                display:'inline-flex',alignItems:'center',gap:8,
                padding:'13px 26px',background:'#2563EB',
                color:'#fff',borderRadius:8,fontSize:15,fontWeight:700,
                textDecoration:'none',transition:'background 0.2s',
                boxShadow:'0 4px 20px rgba(37,99,235,0.45)',
              }}
              onMouseEnter={e => e.currentTarget.style.background='#1D4ED8'}
              onMouseLeave={e => e.currentTarget.style.background='#2563EB'}
              >
                Explore Programs
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </Link>
              <button
                onClick={() => setShowApply(true)}
                style={{
                  display:'inline-flex',alignItems:'center',gap:10,
                  padding:'13px 24px',background:'transparent',
                  color:'#E2E8F0',border:'1.5px solid rgba(148,163,184,0.35)',
                  borderRadius:8,fontSize:15,fontWeight:600,cursor:'pointer',
                  transition:'all 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(96,165,250,0.6)'; e.currentTarget.style.color='#93C5FD'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='rgba(148,163,184,0.35)'; e.currentTarget.style.color='#E2E8F0'; }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013 5.18a2 2 0 012-2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.91 9.91a16 16 0 006.18 6.18l1.27-1.34a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                </svg>
                Talk to an Advisor
              </button>
            </div>
          </div>

          {/* ── RIGHT: Floating badges ── */}
          <div id="home-hero-right" style={{ display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:28,height:530 }}>

            <style>{`
              @keyframes floatBadge {
                0%,100%{ transform:translateY(0px); }
                50%    { transform:translateY(-10px); }
              }
              .hero-badge { animation:floatBadge 4s ease-in-out infinite; }
            `}</style>

            <div className="hero-badge" style={{ animationDuration:'4s',display:'flex',alignItems:'center',gap:12,background:'rgba(6,14,34,0.96)',border:'1px solid rgba(96,130,220,0.42)',borderRadius:12,padding:'14px 22px',boxShadow:'0 4px 28px rgba(0,0,0,0.5)',width:'100%',maxWidth:280 }}>
              <div style={{ width:38,height:38,borderRadius:8,background:'rgba(37,99,235,0.22)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
              </div>
              <span style={{ fontSize:14,fontWeight:700,color:'#E2E8F0',letterSpacing:'0.05em' }}>REAL PROJECTS</span>
            </div>

            <div className="hero-badge" style={{ animationDuration:'5s',animationDelay:'1.2s',display:'flex',alignItems:'center',gap:12,background:'rgba(45,15,90,0.93)',border:'1px solid rgba(147,51,234,0.52)',borderRadius:12,padding:'14px 22px',boxShadow:'0 4px 28px rgba(80,0,150,0.38)',width:'100%',maxWidth:280 }}>
              <div style={{ width:38,height:38,borderRadius:8,background:'rgba(147,51,234,0.28)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C084FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>
              </div>
              <span style={{ fontSize:14,fontWeight:700,color:'#E9D5FF',letterSpacing:'0.05em' }}>PRACTICAL TRAINING</span>
            </div>

            <div className="hero-badge" style={{ animationDuration:'4.5s',animationDelay:'2.5s',display:'flex',alignItems:'center',gap:12,background:'rgba(3,28,16,0.93)',border:'1px solid rgba(22,163,74,0.52)',borderRadius:12,padding:'14px 22px',boxShadow:'0 4px 28px rgba(0,80,30,0.42)',width:'100%',maxWidth:280 }}>
              <div style={{ width:38,height:38,borderRadius:8,background:'rgba(22,163,74,0.22)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4ADE80" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              </div>
              <span style={{ fontSize:14,fontWeight:700,color:'#BBF7D0',letterSpacing:'0.05em' }}>CAREER READY</span>
            </div>

          </div>

        </div>
      </section>

      {/* ══════════════════════════════════════════════
          OUR PROGRAMS SECTION
      ══════════════════════════════════════════════ */}
      <section id="programs" style={{ background:'#F8FAFF',padding:'64px 5% 72px',borderTop:'1px solid #E2E8F0' }}>
        <div style={{ maxWidth:1200,margin:'0 auto' }}>

          {/* Section heading */}
          <div style={{ textAlign:'center',marginBottom:48 }}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginBottom:10 }}>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
              </div>
              <h2 style={{ fontSize:28,fontWeight:900,color:'#1E3A8A',margin:0,letterSpacing:'0.04em' }}>OUR PROGRAMS</h2>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
              </div>
            </div>
            <p style={{ fontSize:15,color:'#64748B',margin:0 }}>Choose the right path to kickstart your tech career</p>
          </div>

          {/* Cards grid */}
          <div id="home-prog-grid" style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:22 }}>
            {PROGRAM_CARDS.map((card, i) => {
              const prog = programs[i]
              const link = card.path || (prog ? `/programDetail/${prog.program_id}` : '/programs')
              const displayName = card.key === 'esprp' ? card.name : (prog?.program_name || card.name)
              return (
                <div key={card.key} style={{
                  background:'#fff',borderRadius:14,
                  border:'1.5px solid #E8EDF5',
                  overflow:'hidden',display:'flex',flexDirection:'column',
                  boxShadow:'0 2px 16px rgba(15,23,42,0.07)',
                  transition:'transform 0.22s,box-shadow 0.22s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-5px)'; e.currentTarget.style.boxShadow=`0 16px 40px rgba(15,23,42,0.13)`; }}
                onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 2px 16px rgba(15,23,42,0.07)'; }}
                >
                  {/* Card header: icon + name + tagline */}
                  <div style={{ padding:'22px 20px 14px',display:'flex',alignItems:'flex-start',gap:14 }}>
                    <div style={{ width:52,height:52,borderRadius:12,background:card.accent,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,boxShadow:`0 4px 14px ${card.accent}55` }}>
                      {card.iconWhite}
                    </div>
                    <div style={{ flex:1,minWidth:0 }}>
                      <h3 style={{ fontSize:15,fontWeight:900,color:card.accent,margin:'0 0 4px',lineHeight:1.2,whiteSpace:'pre-line' }}>
                        {displayName.replace(' ', '\n').toUpperCase()}
                      </h3>
                      <p style={{ fontSize:11.5,color:'#64748B',margin:0,lineHeight:1.4 }}>{card.tagline}</p>
                    </div>
                  </div>

                  {/* Duration */}
                  {card.duration && (
                    <div style={{ textAlign:'center',padding:'0 20px 14px' }}>
                      <span style={{ fontSize:12.5,fontWeight:800,color:card.durationColor,letterSpacing:'0.04em' }}>
                        {card.duration}
                      </span>
                    </div>
                  )}

                  {/* Sub-label for ESPRP */}
                  {card.subLabel && (
                    <div style={{ padding:'0 20px 12px' }}>
                      <span style={{ fontSize:12.5,fontWeight:700,color:'#374151' }}>{card.subLabel}</span>
                    </div>
                  )}

                  <div style={{ height:1,background:'#F1F5F9',margin:'0 20px' }} />

                  {/* Feature list */}
                  <div style={{ padding:'14px 20px',flex:1,display:'flex',flexDirection:'column',gap:9 }}>
                    {card.features.map((f, fi) => (
                      <div key={fi} style={{ display:'flex',alignItems:'flex-start',gap:8 }}>
                        <Check color={card.accent} />
                        <span style={{ fontSize:12.5,color:'#374151',lineHeight:1.45 }}>{f}</span>
                      </div>
                    ))}
                  </div>

                  {/* Know More button */}
                  <div style={{ padding:'16px 20px 22px' }}>
                    <Link to={link} style={{
                      display:'block',width:'100%',textAlign:'center',
                      padding:'11px',background:card.btnBg,color:'#fff',
                      borderRadius:8,fontSize:14,fontWeight:700,textDecoration:'none',
                      transition:'opacity 0.18s,transform 0.18s',boxSizing:'border-box',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.opacity='0.88'; e.currentTarget.style.transform='scale(0.98)'; }}
                    onMouseLeave={e => { e.currentTarget.style.opacity='1'; e.currentTarget.style.transform='scale(1)'; }}
                    >
                      Know More
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* ════════ ESPRP HIGHLIGHT ════════ */}
      <section id="home-esprp" style={{ background:'#EEF2FF', padding:'48px 5%' }}>
        <div id="esprp" style={{ maxWidth:1200, margin:'0 auto', background:'#ffffff', borderRadius:16, border:'1.5px solid #C7D2FE', padding:'36px 40px', boxShadow:'0 8px 36px rgba(79,70,229,0.09)' }}>

          {/* Header */}
          <div style={{ textAlign:'center', marginBottom:36 }}>
            <h2 style={{ fontSize:20, fontWeight:900, color:'#1E1B4B', margin:'0 0 8px', letterSpacing:'0.01em' }}>
              ESPRP – EMPLOYABILITY SKILLS &amp; PLACEMENT READINESS PROGRAM
            </h2>
            <p style={{ fontSize:13.5, color:'#6B7280', margin:0 }}>Empowering students to master assessments and interviews with confidence</p>
          </div>

          {/* Features row + Program Modes */}
          <div id="home-esprp-row" style={{ display:'flex', alignItems:'stretch', gap:0 }}>

            {/* Feature 1 — Written Test Training */}
            <div style={{ flex:'1.3', padding:'0 28px 0 4px' }}>
              <div style={{ width:54, height:54, borderRadius:14, background:'#E0E7FF', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:14 }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              <p style={{ fontSize:13.5, fontWeight:800, color:'#1E1B4B', margin:'0 0 8px', lineHeight:1.3 }}>Comprehensive Test Preparation</p>
              <p style={{ fontSize:12, color:'#6B7280', margin:0, lineHeight:1.7 }}>Aptitude &amp; Skills Training, Coding &amp; Problem-Solving Mastery</p>
            </div>

            {/* Divider */}
            <div className="home-esprp-divider" style={{ width:1, background:'#C7D2FE', alignSelf:'stretch', flexShrink:0 }} />

            {/* Feature 2 — Interview Preparation */}
            <div style={{ flex:1, padding:'0 24px', textAlign:'center' }}>
              <div style={{ width:54, height:54, borderRadius:'50%', background:'#E0E7FF', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
                </svg>
              </div>
              <p style={{ fontSize:13, fontWeight:700, color:'#1E1B4B', margin:0, lineHeight:1.45 }}>Interview Mastery</p>
            </div>

            {/* Divider */}
            <div className="home-esprp-divider" style={{ width:1, background:'#C7D2FE', alignSelf:'stretch', flexShrink:0 }} />

            {/* Feature 3 — Resume Optimization */}
            <div style={{ flex:1, padding:'0 24px', textAlign:'center' }}>
              <div style={{ width:54, height:54, borderRadius:'50%', background:'#E0E7FF', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/><line x1="12" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              <p style={{ fontSize:13, fontWeight:700, color:'#1E1B4B', margin:0, lineHeight:1.45 }}>Resume Optimization</p>
            </div>

            {/* Divider */}
            <div className="home-esprp-divider" style={{ width:1, background:'#C7D2FE', alignSelf:'stretch', flexShrink:0 }} />

            {/* Feature 4 — Career Mentorship */}
            <div style={{ flex:1, padding:'0 24px', textAlign:'center' }}>
              <div style={{ width:54, height:54, borderRadius:'50%', background:'#E0E7FF', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/>
                  <line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/>
                  <line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/>
                </svg>
              </div>
              <p style={{ fontSize:13, fontWeight:700, color:'#1E1B4B', margin:0, lineHeight:1.45 }}>Career Mentorship &amp; Placement Assistance</p>
            </div>

            {/* Divider */}
            <div className="home-esprp-divider" style={{ width:1, background:'#C7D2FE', alignSelf:'stretch', flexShrink:0 }} />

            {/* Program Modes */}
            <div style={{ flex:'1.1', padding:'0 4px 0 28px' }}>
              <p style={{ fontSize:11.5, fontWeight:800, color:'#4338CA', textTransform:'uppercase', letterSpacing:'0.12em', marginBottom:16 }}>Program Modes</p>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, textAlign:'center' }}>
                {[
                  { label:'Online\nPrograms',  icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg> },
                  { label:'Offline\nPrograms', icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
                  { label:'Hybrid\nPrograms',  icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
                ].map((m) => (
                  <div key={m.label} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:8 }}>
                    <div style={{ width:46, height:46, borderRadius:'50%', background:'#E0E7FF', display:'flex', alignItems:'center', justifyContent:'center' }}>{m.icon}</div>
                    <span style={{ fontSize:11, fontWeight:600, color:'#312E81', lineHeight:1.4, whiteSpace:'pre-line', textAlign:'center' }}>{m.label}</span>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ════════ EMPLOYABILITY FRAMEWORK ════════ */}
      <section id="home-employ" style={{ background:'#050D1E', padding:'80px 5%' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>

          {/* Header */}
          <div style={{ textAlign:'center', marginBottom:60 }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(37,99,235,0.15)', border:'1px solid rgba(37,99,235,0.35)', borderRadius:50, padding:'5px 18px', marginBottom:16 }}>
              <span style={{ fontSize:10, fontWeight:800, color:'#60A5FA', letterSpacing:'0.12em', textTransform:'uppercase' }}>Employability Assessment Framework</span>
            </div>
            <h2 style={{ fontSize:'clamp(26px,4vw,44px)', fontWeight:900, color:'#FFFFFF', margin:'0 0 14px', letterSpacing:'-0.02em', lineHeight:1.1 }}>
              UPL <span style={{ color:'#60A5FA' }}>Assess. Train.</span> Place.
            </h2>
            <p style={{ fontSize:16, color:'rgba(255,255,255,0.6)', maxWidth:560, margin:'0 auto', lineHeight:1.7 }}>
              A structured 4-step framework that takes students from skill assessment to job placement
            </p>
          </div>

          {/* 4 Steps */}
          <div id="home-employ-steps" style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:20, marginBottom:72 }}>
            {[
              { num:'01', title:'Pre-Skill Assessment', color:'#2563EB', items:['Aptitude Level','Communication Skills','Interview Readiness','Problem-Solving Ability','Employability Index'] },
              { num:'02', title:'Personalized Skill Development', color:'#16A34A', items:['Skill Gap Analysis','Improvement Recommendations','Learning Roadmap','Progress Tracking'] },
              { num:'03', title:'Continuous Assessment', color:'#7C3AED', items:['Practice Tests','Aptitude Challenges','Communication Evaluations','Mock Interviews'] },
              { num:'04', title:'Placement Readiness Evaluation', color:'#EA580C', items:['Employability Score','Placement Readiness Report','Interview Performance Analysis','Improvement Recommendations'] },
            ].map((step, i) => (
              <div key={step.num} style={{ background:'rgba(255,255,255,0.04)', border:`1px solid ${step.color}33`, borderRadius:16, padding:'28px 22px', position:'relative', overflow:'hidden' }}>
                <div style={{ position:'absolute', top:-12, right:-12, fontSize:72, fontWeight:900, color:`${step.color}10`, lineHeight:1, userSelect:'none' }}>{step.num}</div>
                <div style={{ width:40, height:40, borderRadius:10, background:`${step.color}22`, border:`1px solid ${step.color}44`, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:16 }}>
                  <span style={{ fontSize:16, fontWeight:900, color:step.color }}>{step.num}</span>
                </div>
                <h3 style={{ fontSize:14, fontWeight:800, color:'#F1F5F9', margin:'0 0 16px', lineHeight:1.3 }}>Step {i+1}: {step.title}</h3>
                {step.items.map(item => (
                  <div key={item} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:'rgba(255,255,255,0.6)', marginBottom:8 }}>
                    <span style={{ width:5, height:5, borderRadius:'50%', background:step.color, flexShrink:0, display:'inline-block' }}/>
                    {item}
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Audience split */}
          <div id="home-employ-audience" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginBottom:64 }}>

            {/* Students */}
            <div style={{ background:'linear-gradient(135deg,rgba(37,99,235,0.12) 0%,rgba(37,99,235,0.05) 100%)', border:'1.5px solid rgba(37,99,235,0.3)', borderRadius:20, padding:'36px 32px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:28 }}>
                <div style={{ width:48, height:48, borderRadius:12, background:'rgba(37,99,235,0.2)', border:'1px solid rgba(37,99,235,0.4)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
                </div>
                <div>
                  <div style={{ fontSize:11, fontWeight:800, color:'#60A5FA', letterSpacing:'0.1em', textTransform:'uppercase' }}>For Students</div>
                  <div style={{ fontSize:18, fontWeight:800, color:'#fff' }}>Students Gain</div>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {['Strong Aptitude Skills','Effective Communication','Interview Confidence','Resume Development','LinkedIn Optimization','Mock Placement Experience','Career Guidance','Industry Exposure','Placement Opportunities'].map(b => (
                  <div key={b} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'rgba(255,255,255,0.8)' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    {b}
                  </div>
                ))}
              </div>
              <Link to="/programDetail/4" style={{ display:'inline-flex', alignItems:'center', gap:8, marginTop:28, padding:'11px 24px', background:'#2563EB', color:'#fff', borderRadius:8, fontSize:13.5, fontWeight:700, textDecoration:'none' }} onClick={() => window.scrollTo(0,0)}>
                Explore ESPRP →
              </Link>
            </div>

            {/* Institutions */}
            <div style={{ background:'linear-gradient(135deg,rgba(234,88,12,0.12) 0%,rgba(234,88,12,0.05) 100%)', border:'1.5px solid rgba(234,88,12,0.3)', borderRadius:20, padding:'36px 32px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:28 }}>
                <div style={{ width:48, height:48, borderRadius:12, background:'rgba(234,88,12,0.18)', border:'1px solid rgba(234,88,12,0.35)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FB923C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                </div>
                <div>
                  <div style={{ fontSize:11, fontWeight:800, color:'#FB923C', letterSpacing:'0.1em', textTransform:'uppercase' }}>For Institutions</div>
                  <div style={{ fontSize:18, fontWeight:800, color:'#fff' }}>Institution Benefits</div>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {['Improved Placement %','Enhanced Employability','Industry-Aligned Skills','Placement Analytics','Student Progress Reports','Placement Framework','Industry Expert Sessions','Recruitment Drive Support','Career Development Programs'].map(b => (
                  <div key={b} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, color:'rgba(255,255,255,0.8)' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FB923C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    {b}
                  </div>
                ))}
              </div>
              <Link to="/contact" style={{ display:'inline-flex', alignItems:'center', gap:8, marginTop:28, padding:'11px 24px', background:'#EA580C', color:'#fff', borderRadius:8, fontSize:13.5, fontWeight:700, textDecoration:'none' }} onClick={() => window.scrollTo(0,0)}>
                Partner With UPL →
              </Link>
            </div>

          </div>

          {/* Company types + Commitment strip */}
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.08)', paddingTop:48 }}>
            <div style={{ textAlign:'center', marginBottom:28 }}>
              <span style={{ fontSize:13, fontWeight:700, color:'rgba(255,255,255,0.45)', letterSpacing:'0.08em', textTransform:'uppercase' }}>We Collaborate With</span>
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', gap:12, marginBottom:48 }}>
              {['IT Service Companies','Product-Based Companies','Startups','Analytics Firms','FinTech Organizations','EdTech Companies','Research Organizations'].map(c => (
                <span key={c} style={{ padding:'8px 18px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:50, fontSize:13, color:'rgba(255,255,255,0.7)', fontWeight:500 }}>{c}</span>
              ))}
            </div>
            {/* Commitment strip */}
            <div style={{ background:'rgba(37,99,235,0.1)', border:'1px solid rgba(37,99,235,0.25)', borderRadius:14, padding:'24px 32px', textAlign:'center' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, flexWrap:'wrap', marginBottom:12 }}>
                {['Assess','Train','Practice','Evaluate','Place'].map((step, i, arr) => (
                  <React.Fragment key={step}>
                    <span style={{ fontSize:15, fontWeight:800, color:'#60A5FA' }}>{step}</span>
                    {i < arr.length-1 && <span style={{ color:'rgba(255,255,255,0.3)', fontSize:18 }}>→</span>}
                  </React.Fragment>
                ))}
              </div>
              <p style={{ fontSize:13.5, color:'rgba(255,255,255,0.55)', margin:0, lineHeight:1.7 }}>
                UPL's framework creates confident, industry-ready graduates equipped to succeed in both service-based and product-based organizations.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* ════════ STATS + COLLEGES ════════ */}
      <section id="home-stats" style={{ background:'#0B1629', padding:'52px 5%' }}>
        <div id="home-stats-grid" style={{ maxWidth:1200, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(4,1fr) 1.5fr', gap:0, alignItems:'center' }}>

          {STATS.map((st, i) => (
            <div key={st.label} style={{ textAlign:'center', padding:'20px 16px', borderRight:'1px solid rgba(255,255,255,0.08)', position:'relative' }}>
              <div style={{ display:'flex', justifyContent:'center', marginBottom:12 }}>
                <div style={{ width:54, height:54, borderRadius:'50%', border:'1.5px solid rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(255,255,255,0.04)' }}>
                  {st.icon}
                </div>
              </div>
              <div style={{ fontSize:40, fontWeight:900, color:'#fff', lineHeight:1, marginBottom:8, letterSpacing:'-0.02em' }}>{st.value}</div>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.5)', fontWeight:600, letterSpacing:'0.04em' }}>{st.label}</div>
            </div>
          ))}

          {/* Colleges / Institutions card */}
          <div id="home-stats-colleges" style={{ padding:'0 0 0 32px' }}>
            <div style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:14, padding:'28px 24px', textAlign:'left' }}>
              <div style={{ width:54, height:54, borderRadius:12, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:14 }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.75)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
                  <line x1="12" y1="2" x2="12" y2="9"/>
                </svg>
              </div>
              <p style={{ fontSize:16, fontWeight:800, color:'#F1F5F9', margin:'0 0 8px', letterSpacing:'0.01em' }}>Colleges / Institutions</p>
              <p style={{ fontSize:12.5, color:'rgba(255,255,255,0.45)', margin:'0 0 20px', lineHeight:1.6 }}>We invite colleges to send their enquiries for discussions.</p>
              <Link to="/contact"
                style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'11px 22px', background:'#F59E0B', color:'#fff', borderRadius:8, fontSize:13, fontWeight:700, textDecoration:'none', transition:'background 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.background='#D97706'}
                onMouseLeave={e => e.currentTarget.style.background='#F59E0B'}
                onClick={() => window.scrollTo(0,0)}
              >
                Enquire Now
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </Link>
            </div>
          </div>

        </div>
      </section>

      {/* ════════ HOW IT WORKS ════════ */}
      <section id="home-howitworks" style={{ background:'#FFFFFF',padding:'64px 5%' }}>
        <div id="how-it-works" />
        <div style={{ maxWidth:1200,margin:'0 auto' }}>
          <div style={{ textAlign:'center',marginBottom:48 }}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginBottom:10 }}>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
              </div>
              <h2 style={{ fontSize:28,fontWeight:900,color:'#1E3A8A',margin:0,letterSpacing:'0.04em' }}>HOW IT WORKS</h2>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
              </div>
            </div>
            <p style={{ fontSize:15,color:'#64748B',margin:0 }}>Simple steps to your dream career</p>
          </div>

          <div id="home-hiw-grid" style={{ display:'flex',alignItems:'flex-start',justifyContent:'center',gap:0 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <React.Fragment key={step.num}>
                <div style={{ display:'flex',flexDirection:'column',alignItems:'center',textAlign:'center',minWidth:170,maxWidth:190,padding:'0 8px',flexShrink:0 }}>
                  <div style={{ width:74,height:74,borderRadius:'50%',background:'#F0F6FF',border:'2px solid #BFDBFE',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:14,position:'relative' }}>
                    {step.icon}
                    <span style={{ position:'absolute',top:-8,right:-8,width:24,height:24,borderRadius:'50%',background:'#2563EB',color:'#fff',fontSize:11,fontWeight:900,display:'flex',alignItems:'center',justifyContent:'center' }}>{step.num}</span>
                  </div>
                  <p style={{ fontSize:14,fontWeight:800,color:'#2563EB',margin:'0 0 6px' }}>{step.num}. {step.title}</p>
                  <p style={{ fontSize:12,color:'#64748B',margin:0,lineHeight:1.55 }}>{step.desc}</p>
                </div>
                {i < HOW_IT_WORKS.length - 1 && (
                  <div className="home-hiw-arrow" style={{ display:'flex',alignItems:'center',paddingTop:28,flexShrink:0,color:'#CBD5E1' }}>
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* ════════ TESTIMONIALS ════════ */}
      <section id="home-testimonials" style={{ background:'#F8FAFC',padding:'64px 5%',borderTop:'1px solid #E2E8F0' }}>
        <div id="success-stories" />
        <div style={{ maxWidth:1200,margin:'0 auto' }}>
          <div style={{ textAlign:'center',marginBottom:44 }}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginBottom:10 }}>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
              </div>
              <h2 style={{ fontSize:28,fontWeight:900,color:'#1E3A8A',margin:0,letterSpacing:'0.04em' }}>WHAT OUR STUDENTS SAY</h2>
              <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
                <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
              </div>
            </div>
          </div>
          <div style={{ display:'flex',alignItems:'center',gap:14 }}>
            <button onClick={() => setSlideIdx(i => Math.max(0, i - 1))} disabled={slideIdx === 0} style={{ width:40,height:40,borderRadius:'50%',border:'1.5px solid #E2E8F0',background:'#fff',cursor:slideIdx===0?'not-allowed':'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,opacity:slideIdx===0?0.4:1,transition:'all 0.2s' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div style={{ flex:1,overflow:'hidden' }}>
              <div id="home-test-grid" style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:20 }}>
                {testimonials.length === 0 ? (
                  <p style={{ gridColumn:'1/-1',textAlign:'center',color:'#94A3B8',padding:'32px 0' }}>No testimonials yet.</p>
                ) : testimonials.slice(slideIdx, slideIdx + 3).map((t) => (
                  <div key={t.testimonial_id} style={{ background:'#fff',borderRadius:12,border:'1px solid #E2E8F0',padding:'22px',boxShadow:'0 2px 12px rgba(0,0,0,0.05)' }}>
                    <div style={{ display:'flex',gap:3,marginBottom:14 }}>
                      {[1,2,3,4,5].map((i) => (
                        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill={i <= (t.rating || 5) ? '#F59E0B' : '#E2E8F0'}>
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                      ))}
                    </div>
                    <p style={{ fontSize:13.5,color:'#475569',lineHeight:1.7,margin:'0 0 20px',fontStyle:'italic' }}>"{t.feedback}"</p>
                    <div style={{ display:'flex',alignItems:'center',gap:12 }}>
                      <div style={{ width:42,height:42,borderRadius:'50%',background:'linear-gradient(135deg,#0D9488,#2563EB)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:15,fontWeight:800,color:'#fff',flexShrink:0 }}>{getInitials(t.candidate_name)}</div>
                      <div>
                        <div style={{ fontSize:14,fontWeight:700,color:'#0F172A' }}>{t.candidate_name}</div>
                        <div style={{ fontSize:12,color:'#94A3B8',marginTop:2 }}>{t.job_role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button onClick={() => setSlideIdx(i => Math.min(maxSlide, i + 1))} disabled={slideIdx >= maxSlide} style={{ width:40,height:40,borderRadius:'50%',border:'1.5px solid #E2E8F0',background:'#fff',cursor:slideIdx>=maxSlide?'not-allowed':'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,opacity:slideIdx>=maxSlide?0.4:1,transition:'all 0.2s' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
        </div>
      </section>

      {/* ════════ HIRING PARTNERS ════════ */}
      <section style={{ background:'#FFFFFF',padding:'52px 5%',borderTop:'1px solid #E2E8F0' }}>
        <div style={{ maxWidth:1100,margin:'0 auto',textAlign:'center' }}>
          <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:14,marginBottom:32 }}>
            <div style={{ display:'flex',alignItems:'center',gap:4 }}>
              <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
              <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
            </div>
            <h2 style={{ fontSize:22,fontWeight:900,color:'#1E3A8A',margin:0,letterSpacing:'0.06em' }}>OUR HIRING PARTNERS</h2>
            <div style={{ display:'flex',alignItems:'center',gap:4 }}>
              <span style={{ width:8,height:2,background:'#93C5FD',display:'inline-block',borderRadius:2 }} />
              <span style={{ width:24,height:2,background:'#CBD5E1',display:'inline-block',borderRadius:2 }} />
            </div>
          </div>
          <div style={{ display:'flex',flexWrap:'wrap',justifyContent:'center',alignItems:'center',gap:24 }}>
            {(hiringPartners.length > 0 ? hiringPartners : FALLBACK_PARTNERS).map((p) => (
              <div key={p.name}
                style={{ display:'flex',alignItems:'center',justifyContent:'center',padding:'14px 28px',border:'1.5px solid #E2E8F0',borderRadius:10,background:'#fff',minWidth:120,height:70,transition:'border-color 0.2s,box-shadow 0.2s',cursor:'default' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#2563EB'; e.currentTarget.style.boxShadow='0 4px 18px rgba(37,99,235,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='#E2E8F0'; e.currentTarget.style.boxShadow='none'; }}
              >
                <img
                  src={p.logo_url}
                  alt={p.name}
                  style={{ maxHeight:40,maxWidth:110,objectFit:'contain',filter:'grayscale(30%)' }}
                  onError={e => { e.currentTarget.style.display='none'; e.currentTarget.nextSibling.style.display='block'; }}
                />
                <span style={{ display:'none',fontSize:15,fontWeight:800,color:'#475569' }}>{p.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════ CTA ════════ */}
      <section id="home-cta" style={{ background:'#0A1628',padding:'48px 5%' }}>
        <div id="home-cta-inner" style={{ maxWidth:1100,margin:'0 auto',display:'flex',alignItems:'center',justifyContent:'space-between',gap:32,flexWrap:'wrap' }}>
          <div style={{ display:'flex',alignItems:'center',gap:18 }}>
            <div style={{ width:50,height:50,borderRadius:'50%',background:'linear-gradient(135deg,#0EA5E9,#2563EB)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2z"/></svg>
            </div>
            <div>
              <h3 style={{ fontSize:22,fontWeight:900,color:'#fff',margin:'0 0 5px' }}>Ready to start your journey?</h3>
              <p style={{ fontSize:13.5,color:'rgba(255,255,255,0.5)',margin:0 }}>Join thousands of learners who are building their dream careers with UPL SNIPE.</p>
            </div>
          </div>
          <Link to="/request-callback" style={{ display:'inline-flex',alignItems:'center',gap:8,padding:'14px 32px',background:'#F59E0B',color:'#fff',borderRadius:8,fontSize:15,fontWeight:700,textDecoration:'none',flexShrink:0,transition:'background 0.2s',boxShadow:'0 4px 20px rgba(245,158,11,0.35)' }}
          onMouseEnter={e => e.currentTarget.style.background='#D97706'}
          onMouseLeave={e => e.currentTarget.style.background='#F59E0B'}
          >
            Apply Now
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </Link>
        </div>
      </section>

      {showApply && (
        <RequestCallback isModal onClose={() => setShowApply(false)} />
      )}
    </div>
  )
}

export default Home
